module.exports = "/_next/static/images/profilealt-1331cc57e507704bd4a656592c0dc57d.svg";